import { Component, HostBinding, HostListener, Input, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { WINDOW } from '@frontend/vanilla/core';

@Component({
    selector: 'bs-digital-taxation-info-help-text',
    template: ``,
    styles: [
        `
            :host(.betslip-taxation-info_more-info-text) {
                font-size: 0.8em;
                display: block;
                text-align: left;
                margin-top: 15px;
                margin-bottom: 10px;
                line-height: 1.5;
            }

            ::ng-deep .betslip-taxation-info_more-info-text > span {
                color: var(--betslip-taxation-info-help-link-color);
                text-decoration: underline;
                cursor: pointer;
            }
        `,
    ],
    standalone: false,
})
export default class TaxationInfoHelpTextComponent {
    private readonly _window = inject(WINDOW);

    @HostBinding('innerHtml') @Input() helpText: SafeHtml;
    @Input() helpUrl: string;
    @HostBinding('class') className = 'betslip-taxation-info_more-info-text';

    @HostListener('click')
    openTaxationHelp(): void {
        this._window.open(this.helpUrl, '_blank');
    }
}
